import { css, SerializedStyles } from "@emotion/react";
import { getCSSIOSSuffix } from "./DeviceUtils";

export const hasNotch = () => getCSSIOSSuffix() !== "";

export const onDeviceWithNotch = (style: SerializedStyles) => {
  return () =>
    hasNotch()
      ? css`
          ${style}
        `
      : css``;
};
